<template>
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Agenda', href: route('agenda.index') },
          ]"
        />
        <div class="grid grid-cols-1 gap-6 leading-6 lg:grid-cols-3">
          <div class="order-2 col-span-1 space-y-6 lg:order-1">
            <div>
              <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
                <div
                  class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
                >
                  <h2
                    class="flex items-center text-lg font-bold text-white sm:text-xl"
                  >
                    <i class="mr-2 fa-solid fa-calendar-plus sm:mr-3"></i>
                    {{ form.id ? "Edit Agenda" : "Tambah Agenda" }}
                  </h2>
                </div>
                <div class="p-4 sm:p-6">
                  <form class="space-y-4" @submit.prevent="submit">
                    <div v-if="form.imagePreview.length">
                      <p class="mb-2 font-medium">Preview:</p>
                      <div class="flex flex-wrap gap-2">
                        <img
                          v-for="(src, index) in form.imagePreview"
                          :key="index"
                          :src="src"
                          class="object-cover w-32 h-32 rounded"
                        />
                      </div>
                    </div>

                    <div>
                      <label
                        for="title"
                        class="block text-sm font-medium text-gray-700"
                        >Judul</label
                      >
                      <input
                        v-model="form.judul"
                        type="text"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      />
                      <InputError :message="form.errors.judul" class="mt-2" />
                    </div>

                    <div>
                      <label
                        for="content"
                        class="block text-sm font-medium text-gray-700"
                        >Deskripsi</label
                      >
                      <textarea
                        v-model="form.deskripsi"
                        id="content"
                        name="content"
                        rows="6"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      ></textarea>
                      <InputError
                        :message="form.errors.deskripsi"
                        class="mt-2"
                      />
                    </div>

                    <div>
                      <label
                        for="image"
                        class="block text-sm font-medium text-gray-700"
                        >Gambar</label
                      >

                      <input
                        type="file"
                        ref="fileInput"
                        accept="image/*"
                        multiple
                        @change="handleFileChange"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                      />
                      <progress
                        v-if="form.progress"
                        :value="form.progress.percentage"
                        max="100"
                        class="w-full mt-2"
                      >
                        {{ form.progress.percentage }}%
                      </progress>
                    </div>

                    <div>
                      <label
                        for="publish_date"
                        class="block text-sm font-medium text-gray-700"
                        >Tanggal Mulai</label
                      >
                      <input
                        v-model="form.tanggal_mulai"
                        type="date"
                        id="publish_date"
                        name="publish_date"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      />
                      <InputError
                        :message="form.errors.tanggal_mulai"
                        class="mt-2"
                      />
                    </div>
                    <div>
                      <label
                        for="publish_date"
                        class="block text-sm font-medium text-gray-700"
                        >Tanggal Selesai</label
                      >
                      <input
                        v-model="form.tanggal_selesai"
                        type="date"
                        id="publish_date"
                        name="publish_date"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      />
                      <InputError
                        :message="form.errors.tanggal_selesai"
                        class="mt-2"
                      />
                    </div>
                    <div>
                      <label
                        for="title"
                        class="block text-sm font-medium text-gray-700"
                        >Lokasi</label
                      >
                      <input
                        v-model="form.lokasi"
                        type="text"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      />
                      <InputError :message="form.errors.lokasi" class="mt-2" />
                    </div>

                    <div>
                      <label
                        for="Kategori"
                        class="block text-sm font-medium text-gray-700"
                        >Status</label
                      >
                      <select
                        v-model="form.status"
                        class="block w-full px-3 py-2.5 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      >
                        <option value="">Pilih</option>
                        <option value="terjadwal">Terjadwal</option>
                        <option value="berlangsung">Berlangsung</option>
                        <option value="selesai">Selesai</option>
                        <option value="dibatalkan">Batal</option>
                        <option value="ditunda">Ditunda</option>
                      </select>
                      <InputError :message="form.errors.status" class="mt-2" />
                    </div>

                    <div class="pt-4">
                      <button
                        type="submit"
                        :disabled="form.processing"
                        class="w-full px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                      >
                        <i class="mr-2 fa-solid fa-floppy-disk"></i>
                        {{ form.processing ? "Menyimpan..." : "Simpan" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="order-1 col-span-1 lg:col-span-2 lg:order-2">
            <!-- Header Section -->
            <div class="mb-4 sm:mb-6">
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
              >
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">
                    Daftar Agenda
                  </h3>
                  <p class="mt-1 text-sm text-gray-600">
                    Kelola agenda kegiatan yang akan datang
                  </p>
                </div>
                <div class="mt-2 text-sm text-gray-500 sm:mt-0">
                  Total: {{ agendas.total || 0 }} agenda
                </div>
              </div>
            </div>
            <div class="relative mb-4">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
              >
                <MagnifyingGlassVue class="w-4 h-4 text-gray-400" />
              </div>
              <input
                v-model="search"
                type="text"
                autocomplete="off"
                placeholder="Search data..."
                id="search"
                class="block w-full px-3 py-2.5 pl-10 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
              />
            </div>
            <div
              class="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
            >
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        #
                      </th>
                      <th
                        scope="col"
                        class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 min-w-[150px]"
                      >
                        Judul
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden md:table-cell min-w-[200px]"
                      >
                        Deskripsi
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 min-w-[120px]"
                      >
                        <span class="hidden sm:inline">Tanggal Mulai</span>
                        <span class="sm:hidden">Mulai</span>
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden sm:table-cell min-w-[120px]"
                      >
                        Tanggal Selesai
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell"
                      >
                        Gambar
                      </th>
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 min-w-[100px]"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        class="relative py-3.5 pl-3 pr-4 sm:pr-6 min-w-[100px]"
                      >
                        <span class="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <!-- Empty state -->
                    <tr v-if="!agendas.data || agendas.data.length === 0">
                      <td colspan="8" class="px-6 py-12 text-center">
                        <div class="flex flex-col items-center justify-center">
                          <i
                            class="mb-3 text-4xl text-gray-400 fa-solid fa-calendar-times"
                          ></i>
                          <h3 class="text-lg font-medium text-gray-900">
                            Tidak ada agenda
                          </h3>
                          <p class="mt-1 text-sm text-gray-500">
                            Belum ada agenda yang ditambahkan.
                          </p>
                        </div>
                      </td>
                    </tr>
                    <!-- Data rows -->
                    <tr
                      v-for="(agenda, index) in agendas.data || []"
                      :key="agenda.id"
                      class="transition-colors duration-150 hover:bg-gray-50"
                    >
                      <td
                        class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6"
                      >
                        {{ getRowNumber(index) }}
                      </td>
                      <td class="px-3 py-4 text-sm text-gray-900">
                        <div class="font-medium">{{ agenda.judul }}</div>
                        <!-- Mobile view: Show description under title on small screens -->
                        <div class="mt-1 text-xs text-gray-500 md:hidden">
                          {{
                            agenda.deskripsi && agenda.deskripsi.length > 50
                              ? agenda.deskripsi.substring(0, 50) + "..."
                              : agenda.deskripsi || ""
                          }}
                        </div>
                      </td>
                      <td
                        class="hidden px-3 py-4 text-sm text-gray-500 md:table-cell"
                      >
                        <div class="max-w-xs truncate">
                          {{ agenda.deskripsi || "" }}
                        </div>
                      </td>
                      <td
                        class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                      >
                        <div class="flex items-center">
                          <i
                            class="mr-1 text-green-500 fa-solid fa-calendar-start sm:mr-2"
                          ></i>
                          <span class="hidden sm:inline">{{
                            agenda.tanggal_mulai
                          }}</span>
                          <span class="sm:hidden">{{
                            new Date(agenda.tanggal_mulai).toLocaleDateString(
                              "id-ID",
                              { day: "2-digit", month: "2-digit" }
                            )
                          }}</span>
                        </div>
                        <!-- Mobile view: Show end date under start date -->
                        <div class="mt-1 text-xs text-gray-400 sm:hidden">
                          <i
                            class="mr-1 text-red-500 fa-solid fa-calendar-check"
                          ></i>
                          {{
                            new Date(agenda.tanggal_selesai).toLocaleDateString(
                              "id-ID",
                              { day: "2-digit", month: "2-digit" }
                            )
                          }}
                        </div>
                      </td>
                      <td
                        class="hidden px-3 py-4 text-sm text-gray-500 whitespace-nowrap sm:table-cell"
                      >
                        <div class="flex items-center">
                          <i
                            class="mr-2 text-red-500 fa-solid fa-calendar-check"
                          ></i>
                          {{ agenda.tanggal_selesai }}
                        </div>
                      </td>
                      <td
                        class="hidden px-3 py-4 text-sm text-gray-500 whitespace-nowrap lg:table-cell"
                      >
                        <div v-if="agenda.gambar" class="flex-shrink-0">
                          <img
                            :src="agenda.gambar"
                            alt="Gambar Agenda"
                            class="object-cover w-12 h-12 rounded-lg shadow-sm lg:w-16 lg:h-16"
                          />
                        </div>
                        <div
                          v-else
                          class="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-lg lg:w-16 lg:h-16"
                        >
                          <i
                            class="text-xs text-gray-400 fa-solid fa-image lg:text-sm"
                          ></i>
                        </div>
                      </td>
                      <td class="px-3 py-4 text-sm whitespace-nowrap">
                        <span
                          :class="{
                            'bg-green-100 text-green-800':
                              agenda.status === 'selesai',
                            'bg-blue-100 text-blue-800':
                              agenda.status === 'terjadwal',
                            'bg-yellow-100 text-yellow-800':
                              agenda.status === 'berlangsung',
                            'bg-red-100 text-red-800':
                              agenda.status === 'dibatalkan',
                            'bg-gray-100 text-gray-800':
                              agenda.status === 'ditunda',
                          }"
                          class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium capitalize lg:px-2.5"
                        >
                          {{ agenda.status }}
                        </span>
                      </td>
                      <td
                        class="relative py-4 pl-3 pr-4 text-sm font-medium text-right sm:pr-6"
                      >
                        <div
                          class="flex items-center justify-end space-x-1 sm:space-x-2"
                        >
                          <Link
                            :href="route('agenda.show', agenda.idagenda)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Edit"
                          >
                            <EditIcons class="w-3 h-3" />
                            <span class="hidden ml-1 sm:inline">Edit</span>
                          </Link>
                          <button
                            @click="deleteAgenda(agenda)"
                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 hover:text-red-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                            title="Delete"
                          >
                            <DeleteIcons class="w-3 h-3" />
                            <span class="hidden ml-1 sm:inline">Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Pagination -->
            <div
              v-if="agendas.last_page && agendas.last_page > 1"
              class="flex justify-center mt-6"
            >
              <Pagination
                :data="agendas"
                :updatedPageNumber="updatedPageNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>
<script setup>
import { ref, computed, watch } from "vue";
import Container from "@/Layouts/Container.vue";
import Pagination from "@/Components/Pagination.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Header from "@/Components/Header.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import InputError from "@/Components/InputError.vue";
import EditIcons from "@/Components/Icons/EditIcons.vue";
import DeleteIcons from "@/Components/Icons/DeleteIcons.vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import Swal from "sweetalert2";

import { Link, useForm, router, usePage } from "@inertiajs/vue3";
const props = defineProps({
  agendas: {
    type: Object,
    required: true,
  },
});

// Search and pagination setup
let search = ref(usePage().props.search || ""),
  pageNumber = ref(1);

let agendaUrl = computed(() => {
  let url = new URL(route("agenda.index"));
  url.searchParams.append("page", pageNumber.value);
  if (search.value) {
    url.searchParams.append("search", search.value);
  }
  return url;
});

// Computed property for safe row numbering
const getRowNumber = computed(() => {
  return (index) => {
    const currentPage = props.agendas?.current_page || 1;
    const perPage = props.agendas?.per_page || 10;
    return (currentPage - 1) * perPage + index + 1;
  };
});

const updatedPageNumber = (link) => {
  pageNumber.value = link.url.split("=")[1];
};

watch(
  () => agendaUrl.value,
  (updatedAgendaUrl) => {
    router.visit(updatedAgendaUrl, {
      preserveScroll: true,
      preserveState: true,
      replace: true,
    });
  }
);

watch(
  () => search.value,
  (value) => {
    if (value) {
      pageNumber.value = 1;
    }
  }
);
const form = useForm({
  id: null,
  judul: "",
  deskripsi: "",
  tanggal_mulai: "",
  tanggal_selesai: "",
  lokasi: "",
  status: "",
  image: [],
  imagePreview: [], // untuk tampung URL preview
});

function handleFileChange(e) {
  const files = Array.from(e.target.files);
  form.image = files;
  form.imagePreview = files.map((file) => URL.createObjectURL(file));
}

const fileInput = ref(null);

// Delete function with confirmation
const deleteForm = useForm({});
const deleteAgenda = (agenda) => {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: `Agenda "${agenda.judul}" akan dihapus secara permanen!`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      deleteForm.delete(route("agenda.destroy", agenda.id), {
        onSuccess: () => {
          Swal.fire({
            title: "Berhasil!",
            text: "Agenda berhasil dihapus.",
            icon: "success",
            confirmButtonText: "OK",
          });
        },
        onError: () => {
          Swal.fire({
            title: "Gagal!",
            text: "Terjadi kesalahan saat menghapus agenda.",
            icon: "error",
            confirmButtonText: "OK",
          });
        },
      });
    }
  });
};

const submit = async () => {
  const formData = new FormData();
  formData.append("judul", form.judul);
  formData.append("deskripsi", form.deskripsi);
  formData.append("tanggal_mulai", form.tanggal_mulai);
  formData.append("tanggal_selesai", form.tanggal_selesai);
  formData.append("lokasi", form.lokasi);
  formData.append("status", form.status);

  if (Array.isArray(form.image)) {
    form.image.forEach((file, index) => {
      formData.append(`image[${index}]`, file);
    });
  }

  try {
    form.post(route("agenda.store"), {
      forceFormData: true,
      onSuccess: () => {
        Swal.fire({
          title: "Berhasil!",
          text: "Agenda berhasil disimpan.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          form.reset();
          form.image = [];
          form.imagePreview = [];
          if (fileInput.value) fileInput.value.value = "";

          form.judul = "";
          form.deskripsi = "";
          form.tanggal_mulai = "";
          form.tanggal_selesai = "";
          form.lokasi = "";
          form.status = "";
        });
      },
      onError: (errors) => {
        Swal.fire({
          title: "Gagal!",
          text: "Info: " + (errors.message || "Terjadi kesalahan"),
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    Swal.fire({
      title: "Gagal!",
      text: "Info: " + (error.response?.data.message || "Terjadi kesalahan"),
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};
</script>
